import type { TextColor } from '../../data/v1'
import { ColorModeInspector } from './color-mode'

export type TextColorInspectorProps = {
	mode: 'auto' | 'value'
	onModeChange: (mode: 'auto' | 'value') => void
	value: TextColor
	onChange: (value: TextColor) => void
}

export function TextColorInspector({ mode, onModeChange, value, onChange }: TextColorInspectorProps) {
	return (
		<ColorModeInspector
			label="Text color"
			value={value}
			onChange={onChange}
			optIn={{
				optedIn: mode !== 'auto',
				onOptIn: () => onModeChange('value'),
				onOptOut: () => onModeChange('auto'),
			}}
		/>
	)
}
